module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/engine_inside_backing_4k_bake.png";